<template>
<div class="faq">
    <div v-for="(item, index) in faqs" :key="index" class="dropdown-faq">
        <button class="faq-title" type="button" :aria-expanded="activeIndex === index" @click="toggleFaq(index)">
            <div>{{ item.question }}</div>
            <img src="../assets/down-black.svg" alt="down" :class="{rotate: activeIndex===index}" loading="lazy">
        </button>

        <p v-if="activeIndex === index" class="content" v-html="item.answer">
        </p>
    </div>
</div>
</template>

<script>
export default {
    props: {
        faqs: {
            type: Array,
            required: true
        }
    },
    data() {
        return {
            activeIndex: null
        }
    },
    methods: {
        toggleFaq(index) {
            if (this.activeIndex === index) {
                this.activeIndex = null
            } else {
                this.activeIndex = index
            }
        }
    }
}
</script>
